<template>
  <pages-wrapper>
    <div class="gift-card">
      <h1 class="gift-title">
        {{ pageTitle }}
      </h1>

      <fragment
        prefetch
        slot-name="gift_card_page_head"
      />

      <banners-slot
        :with-category="false"
        slot-name="banner_info_gift"
      />

      <fragment
        prefetch
        slot-name="gift_card_page_footer"
      />
    </div>
  </pages-wrapper>
</template>

<script>
import PagesWrapper from '../../components/info-pages/pages-wrapper';
import BannersSlot from '../../components/banners-slot/banners-slot';
import Fragment from '../../components/info-pages/fragment';
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'gift_card',

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.pageTitle });
  },

  components: {
    Fragment,
    BannersSlot,
    PagesWrapper
  },

  mixins: [pageMetaMixin],

  data: () => ({
    pageTitle: 'Подарочная карта',
  }),
};
</script>

<style lang="scss">
.gift_card {
  //
}
</style>
